import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService } from 'primeng/api';
import { HelpersService } from 'src/app/services';
import { InvoiceService } from 'src/app/services/invoice.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-workshop-jobcard-save-to-collection',
  templateUrl: './workshop-jobcard-save-to-collection.component.html',
  styleUrls: ['./workshop-jobcard-save-to-collection.component.scss']
})
export class WorkshopJobcardSaveToCollectionComponent {

  @Input() collections: any[] = [];
  @Input() sku: any = {};
  @Output() manageCollections = new EventEmitter<void>();


  constructor(
    public activeModal: NgbActiveModal,
    private invoiceService: InvoiceService,
    private helpersService: HelpersService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {

  }

  collectionSelected(collection) {
    var data = {
      PartnerID: this.helpersService.getPartnerId(),
      ProductCollectionID: collection.id,
      InternalProductID: this.sku.InternalProductID,
    };
    this.invoiceService.addProductCollectionLink(data).subscribe((result) => {
      this.activeModal.close({});
    });
  }

  isSKUInCollection(sku: any, collection: any): boolean {
    if (!sku || !collection || !collection.linkedSKUs) {
      return false;
    }
    return collection.linkedSKUs.some((item: any) => item === sku.InternalProductID);
  }

  manageCollectionsEvent() {
    this.activeModal.close({});
    this.manageCollections.emit();
  }
}
